/**
 * Dynamic Variant Title — Enterprise Theme (Clean Canvas)
 */
(function () {
  'use strict';

  function init() {
    var path = window.location.pathname;
    if (path.indexOf('/products/') === -1) return;

    var productUrl = path.split('?')[0] + '.js';
    fetch(productUrl)
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (!product || !product.variants || product.variants.length < 2) return;

        var variantMap = {};
        var allOptionValues = [];
        product.variants.forEach(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(function (o) {
            return o && o !== 'Default' && o !== 'Default Title';
          });
          variantMap[v.id] = { options: opts };
          opts.forEach(function (o) { allOptionValues.push(o.toUpperCase()); });
        });

        var baseTitle = product.title;
        baseTitle = baseTitle.replace(/\s*\([A-Z0-9\-\/]+\)\s*$/, '');
        var dashIdx = baseTitle.lastIndexOf(' - ');
        if (dashIdx > 0) {
          var suffix = baseTitle.substring(dashIdx + 3).trim().toUpperCase();
          var keywords = ['NO CAT', 'WITH CAT', 'PIPE ONLY', 'MUFFLER', 'ALUMINISED', 'STAINLESS',
                          'NO FLARE', 'SINGLE FLARE', 'DOUBLE FLARE', 'MILD STEEL', 'DEFAULT'];
          var isVariantSuffix = keywords.some(function (w) { return suffix.indexOf(w) !== -1; });
          if (!isVariantSuffix) {
            isVariantSuffix = allOptionValues.some(function (v) { return suffix.indexOf(v) !== -1; });
          }
          if (isVariantSuffix) {
            baseTitle = baseTitle.substring(0, dashIdx);
          }
        }
        baseTitle = baseTitle.trim();

        function buildTitle(variantId) {
          var v = variantMap[variantId];
          if (!v) return null;
          var display = baseTitle;
          if (v.options.length > 0) {
            display += ' - ' + v.options.join(' / ');
          }
          return display;
        }

        /* Default to first variant when no ?variant= param in URL */
        var firstVariantId = product.variants[0].id;

        function getVid() {
          var p = new URLSearchParams(window.location.search);
          var v = p.get('variant');
          return v ? parseInt(v, 10) : firstVariantId;
        }

        function applyTitle() {
          var vid = getVid();
          if (!vid) return;
          var title = buildTitle(vid);
          if (!title) return;
          var el = document.querySelector('h1.product-title');
          if (el && el.textContent !== title) {
            el.textContent = title;
          }
        }

        var titleContainer = document.querySelector('[data-dynamic-variant-content*="title"]');
        if (titleContainer) {
          var observer = new MutationObserver(function () {
            setTimeout(applyTitle, 50);
          });
          observer.observe(titleContainer, { childList: true, subtree: true, characterData: true });
        }

        var productInfo = document.querySelector('.product-info, .product-info--sticky');
        if (productInfo && productInfo !== titleContainer) {
          var infoObserver = new MutationObserver(function () {
            setTimeout(applyTitle, 50);
          });
          infoObserver.observe(productInfo, { childList: true, subtree: true });
        }

        applyTitle();

        var origPush = history.pushState;
        var origReplace = history.replaceState;
        history.pushState = function () { origPush.apply(this, arguments); setTimeout(applyTitle, 100); };
        history.replaceState = function () { origReplace.apply(this, arguments); setTimeout(applyTitle, 100); };
        window.addEventListener('popstate', function () { setTimeout(applyTitle, 100); });

        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
          form.addEventListener('change', function () {
            setTimeout(applyTitle, 200);
            setTimeout(applyTitle, 400);
          });
        }

        setInterval(applyTitle, 500);

        console.log('[Dynamic Variant Title] Ready. Base:', baseTitle, '| Variants:', Object.keys(variantMap).length);
      })
      .catch(function (err) {
        console.warn('[Dynamic Variant Title] Failed:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();